export const ADD_WORKSPACE_REQUEST = "ADD_WORKSPACE_REQUEST";
export const ADD_WORKSPACE_SUCCESS = "ADD_WORKSPACE_SUCCESS";
export const ADD_WORKSPACE_FAILURE = "ADD_WORKSPACE_FAILURE";


export const UPDATE_CURRENT_WORKSPACE_REQUEST = "UPDATE_CURRENT_WORKSPACE_REQUEST";
export const UPDATE_CURRENT_WORKSPACE_SUCCESS = "UPDATE_CURRENT_WORKSPACE_SUCCESS";
export const UPDATE_CURRENT_WORKSPACE_FAILURE = "UPDATE_CURRENT_WORKSPACE_FAILURE";


export const ADD_MEMBERS_TO_WORKSPACE_REQUEST = "ADD_MEMBERS_TO_WORKSPACE_REQUEST";
export const ADD_MEMBERS_TO_WORKSPACE_SUCCESS = "ADD_MEMBERS_TO_WORKSPACE_SUCCESS";
export const ADD_MEMBERS_TO_WORKSPACE_FAILURE = "ADD_MEMBERS_TO_WORKSPACE_FAILURE";